import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { disconnect, onChangeServiceDisconnectionDate, setDisconnectDialogVisible } from 'pages/Internet/store/actions';
import {
  getFTTBServiceDisconnectionParams,
  getFTTBServiceIsDisconnectionDialogVisible,
  getFTTBServiceRequestId,
} from 'pages/Internet/store/selectors';
import {
  getFTTBServiceIsDisconnection,
  getFTTBServiceRequestDisconnectionDate,
} from 'pages/Internet/store/selectors/servicesSelectors';
import { DisconnectDialog } from '../../../../components';

export const ServiceDisconnectionDialog = compose(
  connect(
    (state) => ({
      isVisible: getFTTBServiceIsDisconnectionDialogVisible(state),
      params: getFTTBServiceDisconnectionParams(state),
      requestId: getFTTBServiceRequestId(state),
      disconnectionDate: getFTTBServiceRequestDisconnectionDate(state) || new Date(),
      isDisconnecting: getFTTBServiceIsDisconnection(state),
      shouldRender: !!getFTTBServiceIsDisconnectionDialogVisible(state),
    }),
    {
      onDisconnectClick: disconnect,
      onChangeDate: onChangeServiceDisconnectionDate,
      onCancelClick: setDisconnectDialogVisible,
    },
  ),
  withRenderFlag,
)(DisconnectDialog);
